<template>
    <v-layout
        class="set-custom-height"
        :class="{
            'v-theme--dark': isDark,
            'light-mode': !isDark,
        }"
    >
        <v-main>
            <template v-if="screen_loading">
                <div
                    class="d-flex flex-column align-center justify-center pa-4 ga-4"
                    style="height: 100vh; height: 100dvh"
                >
                    <div class="logo-container-wrapper animated-border-card">
                        <div class="logo-container">
                            <img :src="system_mini_logo" class="loading-logo" />
                        </div>
                    </div>
                    <span class="font-size-14 text-muted-foreground"
                        >Loading...</span
                    >
                </div>
            </template>
            <template v-else>
                <v-dialog v-model="alertDialog" max-width="400">
                    <v-card>
                        <v-card-title class="card-title-custom">
                            <img
                                :src="yellowWarningIcon"
                                alt="Warning"
                                style="max-width: 32px; max-height: 32px"
                            />
                            <span>Warning!</span>
                        </v-card-title>
                        <v-card-text class="pb-3">
                            <span class="d-block text-red-accent-2">
                                CASTCORE in this browser is not officially
                                supported.
                            </span>
                            <span class="d-block font-size-14">
                                You may experience some issues. CASTCORE has
                                been designed to work best with Google Chrome
                                and other Chromium-based browsers like Microsoft
                                Edge.
                            </span>
                            <span class="d-block font-size-12 mt-4"
                                >Suggested Browsers</span
                            >
                            <div
                                class="d-flex flex-column gap-2 bg-grey-lighten-4 rounded-lg pa-2"
                            >
                                <div class="d-flex w-100 py-4">
                                    <div class="d-flex w-50">
                                        <img
                                            :src="chrome_icon"
                                            alt="Chrome"
                                            class="ma-auto"
                                            style="
                                                max-width: 64px;
                                                max-height: 64px;
                                            "
                                        />
                                    </div>
                                    <div class="d-flex w-50">
                                        <img
                                            :src="edge_icon"
                                            alt="Edge"
                                            class="ma-auto"
                                            style="
                                                max-width: 64px;
                                                max-height: 64px;
                                            "
                                        />
                                    </div>
                                </div>
                            </div>
                            <v-btn
                                class="px-4 mt-6"
                                variant="flat"
                                color="grey-darken-4"
                                text="I understand and wish to proceed"
                                @click="processAlertDialog"
                                block
                            ></v-btn>
                            <v-checkbox
                                hide-details
                                density="compact"
                                v-model="dont_show_again"
                                label="Don't show this message again"
                            ></v-checkbox>
                        </v-card-text>
                    </v-card>
                </v-dialog>

                <template v-if="showComponent === true">
                    <TopNavBar
                        :project-selected="project_selected"
                        :project-code="select_project_button_code"
                        :project-name="select_project_button_name"
                        :project-type-icon="getProjectTypeIcon()"
                        :is-dark="isDark"
                        :page-title="pageTitle"
                        :menu-icon="menuIcon"
                        @search="openSearchDialog"
                        @toggle-theme="toggleTheme"
                        @change-project="settingDialog = true"
                        @toggle-drawer="drawer = !drawer"
                    />
                    <!-- Module Search Dialog -->
                    <ModuleSearch
                        v-model="showSearchDialog"
                        :project-type="project_type"
                        @module-selected="onModuleSelected"
                    />

                    <v-dialog v-model="settingDialog" max-width="600">
                        <v-card title="Project Shortcut">
                            <v-card-item class="pt-0">
                                <div class="d-flex justify-end mb-2">
                                    <v-btn
                                        text="Clear"
                                        variant="text"
                                        size="small"
                                        color="red-accent-3"
                                        @click="clearProjectShortcut"
                                    ></v-btn>
                                </div>

                                <div class="d-block w-100 custom-tab-container">
                                    <div
                                        class="d-flex custom-tab-bar tab-block-4"
                                        :data-tab="tab"
                                    >
                                        <span
                                            class="tab-item"
                                            :class="
                                                tab === 'tab_1' ? 'active' : ''
                                            "
                                            @click="tab = 'tab_1'"
                                            >Building</span
                                        >

                                        <span
                                            class="tab-item"
                                            :class="
                                                tab === 'tab_2' ? 'active' : ''
                                            "
                                            @click="tab = 'tab_2'"
                                            >Tunnel</span
                                        >

                                        <a
                                            class="tab-item"
                                            :class="
                                                tab === 'tab_3' ? 'active' : ''
                                            "
                                            @click="tab = 'tab_3'"
                                            >Bridge</a
                                        >

                                        <a
                                            class="tab-item"
                                            :class="
                                                tab === 'tab_4' ? 'active' : ''
                                            "
                                            @click="tab = 'tab_4'"
                                            >More</a
                                        >
                                    </div>
                                </div>

                                <v-card-text class="pa-0">
                                    <div
                                        class="d-flex flex-column gap-2"
                                        v-if="tab === 'tab_1'"
                                    >
                                        <div
                                            class="custom-menu-list"
                                            v-if="groupedProjects.building"
                                        >
                                            <div
                                                class="custom-menu-item"
                                                @click="projectShortcut(item)"
                                                v-for="item in groupedProjects.building"
                                                :key="item.id"
                                                :class="
                                                    item.id == select_project_id
                                                        ? 'active'
                                                        : ''
                                                "
                                            >
                                                <div
                                                    class="custom-menu-item-content"
                                                >
                                                    <span
                                                        class="font-size-14 d-block"
                                                    >
                                                        [{{ item.code }}]
                                                        {{ item.name }}
                                                    </span>
                                                    <span
                                                        class="font-size-12 d-block selected-project-mark"
                                                        v-if="
                                                            item.id ==
                                                            select_project_id
                                                        "
                                                    >
                                                        Selected
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <template v-else>
                                            <span
                                                class="d-block py-4 w-100 text-center rounded-lg mt-4 bg-slate-100 text-muted-foreground"
                                            >
                                                No project found.
                                            </span>
                                        </template>
                                    </div>

                                    <div
                                        class="d-flex flex-column gap-2"
                                        v-if="tab === 'tab_2'"
                                    >
                                        <div
                                            class="custom-menu-list"
                                            v-if="groupedProjects.tunnel"
                                        >
                                            <div
                                                class="custom-menu-item"
                                                @click="projectShortcut(item)"
                                                v-for="item in groupedProjects.tunnel"
                                                :key="item.id"
                                                :class="
                                                    item.id == select_project_id
                                                        ? 'active'
                                                        : ''
                                                "
                                            >
                                                <div
                                                    class="custom-menu-item-content"
                                                >
                                                    <span
                                                        class="font-size-14 d-block"
                                                    >
                                                        [{{ item.code }}]
                                                        {{ item.name }}
                                                    </span>
                                                    <span
                                                        class="font-size-12 d-block selected-project-mark"
                                                        v-if="
                                                            item.id ==
                                                            select_project_id
                                                        "
                                                    >
                                                        Selected
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <template v-else>
                                            <span
                                                class="d-block py-4 w-100 text-center rounded-lg mt-4 bg-slate-100 text-muted-foreground"
                                            >
                                                No project found.
                                            </span>
                                        </template>
                                    </div>

                                    <div
                                        class="d-flex flex-column gap-2"
                                        v-if="tab === 'tab_3'"
                                    >
                                        <div
                                            class="custom-menu-list"
                                            v-if="groupedProjects.bridge"
                                        >
                                            <div
                                                class="custom-menu-item"
                                                @click="projectShortcut(item)"
                                                v-for="item in groupedProjects.bridge"
                                                :key="item.id"
                                                :class="
                                                    item.id == select_project_id
                                                        ? 'active'
                                                        : ''
                                                "
                                            >
                                                <div
                                                    class="custom-menu-item-content"
                                                >
                                                    <span
                                                        class="font-size-14 d-block"
                                                    >
                                                        [{{ item.code }}]
                                                        {{ item.name }}
                                                    </span>
                                                    <span
                                                        class="font-size-12 d-block selected-project-mark"
                                                        v-if="
                                                            item.id ==
                                                            select_project_id
                                                        "
                                                    >
                                                        Selected
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <template v-else>
                                            <span
                                                class="d-block py-4 w-100 text-center rounded-lg mt-4 bg-slate-100 text-muted-foreground"
                                            >
                                                No project found.
                                            </span>
                                        </template>
                                    </div>

                                    <div
                                        class="d-flex flex-column gap-2"
                                        v-if="tab === 'tab_4'"
                                    >
                                        <div class="custom-menu-list">
                                            <div class="custom-menu-item">
                                                <a
                                                    href="https://app.casterp.host/"
                                                    target="_blank"
                                                    class="text-decoration-none custom-menu-item-content text-muted-foreground"
                                                >
                                                    <span>Bridge(App)</span>
                                                    <span class="mini-badge">
                                                        External
                                                    </span>
                                                </a>
                                            </div>
                                            <div class="custom-menu-item">
                                                <a
                                                    href="https://komt.casterp.host/"
                                                    target="_blank"
                                                    class="text-decoration-none custom-menu-item-content text-muted-foreground"
                                                >
                                                    <span>
                                                        Castcore Development
                                                    </span>
                                                    <span class="mini-badge">
                                                        External
                                                    </span>
                                                </a>
                                            </div>
                                            <div class="custom-menu-item">
                                                <a
                                                    href="https://testing.casterp.host/"
                                                    target="_blank"
                                                    class="text-decoration-none custom-menu-item-content text-muted-foreground"
                                                >
                                                    <span>
                                                        Castcore Testing
                                                    </span>
                                                    <span class="mini-badge">
                                                        External
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card-item>
                            <template v-slot:actions>
                                <v-btn
                                    class="ms-auto"
                                    text="Ok"
                                    @click="settingDialog = false"
                                ></v-btn>
                            </template>
                        </v-card>
                    </v-dialog>

                    <!-- Sidebar Navigation Drawer -->
                    <v-navigation-drawer
                        v-model="drawer"
                        :temporary="isMobile"
                        :permanent="!isMobile"
                        :rail="false"
                        class="tailwind-sidebar has-top-nav"
                    >
                        <!-- Top Utility Nav (project select; search lives in TopNavBar) -->
                        <div class="sidebar-utility-nav">
                            <div
                                class="sidebar-util-item cursor-pointer"
                                @click="settingDialog = true"
                            >
                                <div class="pa-2 project-icon-frame">
                                    <v-icon
                                        :icon="getProjectTypeIcon()"
                                        size="24"
                                        :class="getProjectIconColor()"
                                    />
                                </div>
                                <div class="d-flex flex-column">
                                    <span class="sidebar-util-label">
                                        {{
                                            project_selected
                                                ? select_project_button_code +
                                                  " · " +
                                                  (select_project_button_name ||
                                                      "")
                                                : "Select Project"
                                        }}
                                    </span>
                                    <span class="sidebar-util-label">
                                        {{ project_type }}
                                    </span>
                                </div>
                                <div
                                    class="sidebar-util-label-small h-100 d-flex ml-auto"
                                >
                                    <v-icon
                                        :icon="mdiChevronRight"
                                        size="small"
                                    />
                                </div>
                            </div>
                        </div>

                        <!-- Navigation Content -->
                        <div
                            class="sidebar-content flex-1 overflow-y-auto"
                            v-if="!sidebar_loading"
                        >
                            <ProjectSelector
                                :data="groupedProjects"
                                v-if="!project_selected"
                                @select-project="projectShortcut"
                            />
                            <SidebarContent
                                v-if="project_selected"
                                :project_type="project_type"
                                :key="project_type"
                            />
                        </div>

                        <!-- Loading State -->
                        <div v-else class="sidebar-content overflow-y-auto">
                            <div class="sidebar-loading-skeleton">
                                <div class="skel-label"></div>
                                <div class="skel-item"></div>
                                <div class="skel-item"></div>
                                <div class="skel-item skel-item--short"></div>
                                <div class="skel-label mt-4"></div>
                                <div class="skel-item"></div>
                                <div class="skel-item skel-item--short"></div>
                            </div>
                        </div>

                        <!-- Bottom: Support / Changelog / User -->
                        <div class="sidebar-bottom">
                            <!-- <div class="sidebar-bottom-divider"></div> -->
                            <div
                                id="menu-activator"
                                class="sidebar-user-row cursor-pointer"
                            >
                                <img
                                    :src="PROFILE_AVATAR"
                                    :alt="USERNAME"
                                    class="sidebar-user-avatar border"
                                />
                                <div class="sidebar-user-info">
                                    <span class="sidebar-user-name">{{
                                        USERNAME || "Unknown User"
                                    }}</span>
                                    <span class="sidebar-user-email">{{
                                        USER_EMAIL || "Unknown Email"
                                    }}</span>
                                </div>
                                <v-icon
                                    :icon="mdiDotsVertical"
                                    size="14"
                                    class="sidebar-user-chevron ml-auto"
                                />
                            </div>
                        </div>

                        <v-menu activator="#menu-activator">
                            <v-dialog max-width="450">
                                <template
                                    v-slot:activator="{ props: activatorProps }"
                                >
                                    <div
                                        class="d-block bg-surface font-size-14 rounded border"
                                    >
                                        <!-- <div
                                            class="d-flex flex-column border-b px-3 py-2"
                                        >
                                            <div
                                                class="text-card-foreground truncate"
                                            >
                                                {{ USERNAME }}
                                            </div>
                                            <div
                                                class="text-muted-foreground font-size-12 truncate"
                                            >
                                                {{ USER_EMAIL }}
                                            </div>
                                        </div> -->
                                        <div class="custom-dropdown-menu pa-1">
                                            <!-- Company Header -->
                                            <div class="sidebar-company-header">
                                                <div
                                                    class="custom-dropdown-menu pa-1 border-b mb-1"
                                                >
                                                    <div
                                                        class="sidebar-company-btn"
                                                        @click="goToHome"
                                                    >
                                                        <div
                                                            class="sidebar-company-logo"
                                                        >
                                                            <img
                                                                :src="
                                                                    system_mini_logo
                                                                "
                                                                :alt="
                                                                    COMPANY_NAME
                                                                "
                                                            />
                                                        </div>
                                                        <span
                                                            class="sidebar-company-name"
                                                            >{{
                                                                "Cast Erp"
                                                            }}</span
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="custom-menu-item"
                                                @click="goToProfile"
                                            >
                                                <div
                                                    class="custom-menu-item-content"
                                                >
                                                    My Profile
                                                </div>
                                            </div>
                                            <router-link
                                                class="custom-menu-item text-decoration-none"
                                                to="/admin-panel/modules?tab=modules"
                                                v-if="USERNAME === 'Admin'"
                                            >
                                                <div
                                                    class="custom-menu-item-content"
                                                >
                                                    System Modules
                                                </div>
                                            </router-link>
                                            <router-link
                                                class="custom-menu-item text-decoration-none"
                                                to="/admin-panel/user-access"
                                                v-if="USERNAME === 'Admin'"
                                            >
                                                <div
                                                    class="custom-menu-item-content"
                                                >
                                                    User Access
                                                </div>
                                            </router-link>
                                            <div
                                                class="custom-menu-item"
                                                @click="settingDialog = true"
                                            >
                                                <div
                                                    class="custom-menu-item-content d-flex align-center ga-2"
                                                >
                                                    Select Project
                                                    <template
                                                        v-if="
                                                            select_project_button_code
                                                        "
                                                    >
                                                        <span
                                                            class="px-1 d-block border rounded font-size-11 text-card-foreground"
                                                        >
                                                            {{
                                                                select_project_button_code
                                                            }}</span
                                                        >
                                                    </template>
                                                </div>
                                            </div>
                                            <div
                                                class="custom-menu-item"
                                                v-bind="activatorProps"
                                            >
                                                <div
                                                    class="custom-menu-item-content"
                                                >
                                                    Switch Company
                                                </div>
                                            </div>
                                            <div
                                                class="custom-menu-item"
                                                @click="alertDialog = true"
                                                v-if="!getThisBrowser()"
                                            >
                                                <div
                                                    class="custom-menu-item-content d-flex align-center ga-2"
                                                >
                                                    <span>Browser Alert</span>
                                                    <v-icon
                                                        :icon="alertIcon2"
                                                        size="x-small"
                                                        class="ms-auto"
                                                        color="warning"
                                                    ></v-icon>
                                                </div>
                                            </div>
                                            <div
                                                class="custom-menu-item"
                                                @click="toggleTheme"
                                            >
                                                <div
                                                    class="custom-menu-item-content d-flex ga-1"
                                                >
                                                    <span class="d-block">
                                                        {{
                                                            isDark
                                                                ? "Light Mode"
                                                                : "Dark Mode"
                                                        }}
                                                    </span>
                                                    <v-icon
                                                        :icon="
                                                            isDark
                                                                ? mdiWeatherSunny
                                                                : mdiWeatherNight
                                                        "
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="custom-dropdown-menu pa-1 border-t red-text"
                                        >
                                            <div
                                                class="custom-menu-item"
                                                @click="logout"
                                            >
                                                <div
                                                    class="custom-menu-item-content"
                                                >
                                                    Logout
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <template v-slot:default="{ isActive }">
                                    <v-card title="Switch Company">
                                        <v-card-text>
                                            <v-card
                                                subtitle="CURRENT SELECTED"
                                                :title="COMPANY_NAME"
                                                theme="dark"
                                                class="mb-3"
                                            >
                                                <template v-slot:prepend>
                                                    <div class="pa-2 rounded">
                                                        <v-icon
                                                            color="deep-purple-accent-2"
                                                            :icon="companyIcon"
                                                        ></v-icon>
                                                    </div>
                                                </template>
                                                <template v-slot:append>
                                                    <v-icon
                                                        color="success"
                                                        :icon="checkedIcon"
                                                    ></v-icon>
                                                </template>
                                            </v-card>
                                            <template
                                                v-if="ALL_COMPANY.length > 1"
                                            >
                                                <span
                                                    class="mb-3 d-block font-weight-bold"
                                                    >Companies</span
                                                >
                                                <template
                                                    v-for="own_company in ALL_COMPANY"
                                                    :key="own_company.id"
                                                >
                                                    <v-list-item
                                                        :title="
                                                            own_company.name
                                                        "
                                                        v-if="
                                                            COMPANY_NAME !==
                                                            own_company.name
                                                        "
                                                        @click="
                                                            changeCompany(
                                                                own_company.id,
                                                            )
                                                        "
                                                    >
                                                    </v-list-item>
                                                </template>
                                            </template>
                                            <template v-if="errors">
                                                <v-chip
                                                    :prepend-icon="alertIcon"
                                                    class="text-red-accent-4 mt-2"
                                                >
                                                    {{ errors }}
                                                </v-chip>
                                            </template>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>

                                            <v-btn
                                                text="Close"
                                                @click="isActive.value = false"
                                            ></v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </template>
                            </v-dialog>
                        </v-menu>
                    </v-navigation-drawer>
                </template>
                <template v-if="$route.meta?.public">
                    <router-view
                        @settingDialog="requestSelectProject($event, true)"
                        @select-project="projectShortcut"
                        :key="refreshKey"
                    />
                </template>
                <div
                    v-else
                    id="set_inner_container_height"
                    class="container-max-width"
                    :class="{
                        'has-top-nav-offset': showComponent,
                        'login-page': !showComponent,
                    }"
                >
                    <div
                        id="page_containter"
                        :class="{ 'has-top-nav': showComponent }"
                    >
                        <router-view
                            id="page_content"
                            @settingDialog="requestSelectProject($event, true)"
                            @select-project="projectShortcut"
                            :key="refreshKey"
                        />
                    </div>
                </div>
            </template>
            <!-- <v-footer class="border-t" style="height: 36px">
        <small class="text-grey"
          >© 2024 - {{ year }} CastCore Precast ERP. All rights reserved. (Ver
          0.9)</small
        >
      </v-footer> -->
        </v-main>
    </v-layout>
</template>

<script>
import {
    mdiChevronDown,
    mdiCheckBold,
    mdiHomeSwitchOutline,
    mdiBellOutline,
    mdiChevronLeft,
    mdiMenu,
    mdiLogout,
    mdiAlertCircleOutline,
    mdiChevronUp,
    mdiChevronRight,
    mdiAlertOutline,
    mdiOfficeBuildingOutline,
    mdiTunnelOutline,
    mdiBridge,
    mdiWeatherSunny,
    mdiWeatherNight,
    mdiDotsVertical,
} from "@mdi/js";
import apiService from "@/apiService";
import { getFirstAllowedPath, isPathAllowed } from "@/router";
import processErrors from "@/js/ProcessErrors";
import ProjectSelector from "@/components/Sidebar/project-selector.vue";
import SidebarContent from "@/components/Sidebar/sidebar-content.vue";
import ModuleSearch from "@/components/Common/ModuleSearch.vue";
import TopNavBar from "@/components/layout/TopNavBar.vue";

export default {
    data() {
        return {
            screen_loading: false,
            system_mini_logo: require("@/assets/system_logo/temp_logo.png"),
            chrome_icon: require("@/assets/chrome_icon.png"),
            edge_icon: require("@/assets/edge_icon.png"),
            shortcutIcon: require("@/assets/shortcut_icon1.png"),
            yellowWarningIcon: require("@/assets/yellow_warning_icon.png"),
            select_project_button_code: "Select Project",
            select_project_button_name: null,
            select_project_id: null,
            project_selected: false,
            project_type: null,
            refreshKey: 0,
            tab: "tab_1",
            isMobile: false,
            showComponent: false,
            settingDialog: false,
            alertDialog: false,
            ALL_COMPANY: null,
            sidebar_loading: false,
            dont_show_again: false,
            drawer: null,
            errors: null,
            permissions: null,
            PROJECT_SHORTCUT: null,
            groupedProjects: {},
            USERNAME: localStorage.getItem("username"),
            USER_EMAIL: localStorage.getItem("email"),
            COMPANY_NAME: localStorage.getItem("current_company"),
            PROFILE_AVATAR: localStorage.getItem("profile_photo"),
            COMPANY_LOGO: localStorage.getItem("company_logo"),
            AVAILABLE_MODULES: localStorage.getItem("available_modules"),
            arrowLeftIcon: mdiChevronLeft,
            mdiChevronRight,
            arrowUpIcon: mdiChevronUp,
            arrowDownIcon: mdiChevronDown,
            checkedIcon: mdiCheckBold,
            companyIcon: mdiHomeSwitchOutline,
            noticeIcon: mdiBellOutline,
            menuIcon: mdiMenu,
            alertIcon: mdiAlertCircleOutline,
            logoutIcon: mdiLogout,
            alertIcon2: mdiAlertOutline,
            mdiOfficeBuildingOutline: mdiOfficeBuildingOutline,
            mdiTunnelOutline,
            mdiBridge,
            mdiDotsVertical,
            mdiWeatherSunny,
            mdiWeatherNight,
            isDark: (localStorage.getItem("color_theme") || "light") === "dark",
            showSearchDialog: false,
            currentRouteName: "",
            year: new Date().getFullYear(),
        };
    },
    components: {
        ProjectSelector,
        SidebarContent,
        ModuleSearch,
        TopNavBar,
    },
    watch: {
        $route(to) {
            this.currentRouteName = to.name;
        },
    },
    computed: {
        pageTitle() {
            if (
                this.currentRouteName === "Tunnel Financial Dashboard" ||
                this.currentRouteName === "Bridge Financial Dashboard" ||
                this.currentRouteName === "Building Financial Dashboard"
            ) {
                return "Financial Dashboard";
            }
            if (this.currentRouteName === "Building Manpower Dashboard") {
                return "Manpower Dashboard";
            }
            return this.currentRouteName || "";
        },
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.checkScreenSize); // Remove resize event listener when component is unmounted
        document.removeEventListener("keydown", this.handleKeydown);
    },
    async created() {
        this.screen_loading = true;
        await this.checkScreenSize();
        window.addEventListener("resize", this.checkScreenSize); // Listen for window resize events
        document.addEventListener("keydown", this.handleKeydown); // Listen for keyboard events
        const token = localStorage.getItem("token");
        if (token) {
            const user_id = localStorage.getItem("user_id");
            if (!user_id) {
                this.logout();
            }
            this.ALL_COMPANY = JSON.parse(
                localStorage.getItem("available_companies"),
            );
            this.sidebar_loading = true;
            // await this.reloadAllModules();
            await this.getProjectShortcut();
            this.sidebar_loading = false;
            console.log("All Modules Loaded");
        }
        this.showComponent = !!token;

        if (!this.showComponent) {
            const element = document.getElementById("app");
            element.style.height = "calc(100% - 36px)";
        }
        this.currentRouteName = this.$route.name;

        // Check browser type
        const browser = this.getThisBrowser();
        if (browser !== true) {
            this.alertDialog = true;
            if (localStorage.getItem("dont_show_alert_dialog")) {
                this.alertDialog = false;
            }
        }

        this.setProjectTitle();

        // if (localStorage.getItem("project")) {
        //     const selected_project = JSON.parse(
        //         localStorage.getItem("project")
        //     );
        // }

        // const selected_project = localStorage.getItem("project");
        // if (!selected_project) {
        //     this.$router.push("/general-dashboard");
        // }

        setTimeout(() => {
            this.screen_loading = false;
        }, 500);
    },
    methods: {
        processAlertDialog() {
            if (this.dont_show_again) {
                localStorage.setItem("dont_show_alert_dialog", true);
            } else {
                localStorage.setItem("dont_show_alert_dialog", false);
            }
            this.alertDialog = false;
        },
        goToHome() {
            this.$router.push({ name: "Home" });
        },
        goToProfile() {
            this.$router.push("/UserProfile");
        },
        async changeCompany($id) {
            try {
                const response = await apiService(
                    `change-company/${$id}`,
                    "put",
                );
                if (response.status === true) {
                    const company_id = response.data.company.id;
                    const current_company = response.data.company.name;
                    const company_code = response.data.company.company_code;
                    const company_logo = response.data.company.logo;
                    localStorage.setItem("company_id", company_id);
                    localStorage.setItem("current_company", current_company);
                    localStorage.setItem("company_code", company_code);
                    localStorage.setItem("company_logo", company_logo);
                    location.reload();
                } else {
                    this.error = "Something when wrong";
                }
            } catch (error) {
                this.errors = error.message;
            }
            // finally {
            //     this.loading = false;
            // }
        },
        async getProjectShortcut() {
            try {
                const response = await apiService(`projects/min`, "get");
                if (response.status === false) {
                    processErrors(response);
                } else {
                    this.PROJECT_SHORTCUT = response.data.projects;
                    this.groupedProjects = {};
                    this.PROJECT_SHORTCUT.forEach((project) => {
                        if (this.building_only) {
                            if (!this.groupedProjects["building"]) {
                                this.groupedProjects["building"] = [];
                            }
                            if (project.type.toLowerCase() == "building") {
                                this.groupedProjects["building"].push(project);
                            }
                        } else {
                            const type = project.type || "Other";
                            if (!this.groupedProjects[type]) {
                                this.groupedProjects[type] = [];
                            }
                            this.groupedProjects[type].push(project);
                        }
                    });
                }
            } catch (error) {
                processErrors(error);
            }
        },
        logout() {
            // Clear in-memory permissions before wiping storage so any
            // subscribers see the reset state.
            this.$store.dispatch("permissions/clear");

            // Clear local storage
            localStorage.clear();

            // Optionally, you might want to redirect the user to the login page
            // You can use Vue Router for this:
            location.reload();
        },
        async checkScreenSize() {
            this.isMobile = window.innerWidth < 768; // Set isMobile to true if screen width is less than 768 pixels
        },
        goBack() {
            this.$router.go(-1); // Go back to the previous page
        },
        async projectShortcut(item, forceReload = false) {
            // const pathName = this.$route.name;
            // const fixedPathNamne = 'Project Information'
            // const newPath = `/Project/View/${id}`;

            // if (pathName !== fixedPathNamne) {
            // this.$router.push(newPath);
            // } else {
            //     // 如果路径相同，强制重新加载组件
            //     this.$router.replace({ path: '/empty', query: { redirect: newPath } })
            //         .then(() => {
            //             this.$router.push(newPath);
            //         });
            // }
            this.screen_loading = true;

            // Capture the previously selected project type BEFORE we overwrite
            // any state, so we can decide whether to stay on the current page.
            const previous_project_type = this.project_type
                ? String(this.project_type).toLowerCase()
                : null;
            const current_route = this.$route;

            const project_info = {
                project_id: item.id,
                project_name: item.name,
                project_code: item.code,
                type: item.type,
            };

            localStorage.setItem("project", JSON.stringify(project_info));

            this.setProjectTitle();

            const new_project_type = project_info.type.toLowerCase();
            const same_project_type =
                previous_project_type !== null &&
                previous_project_type === new_project_type;

            // Type-specific dashboard to use when no module restrictions exist
            const dashboardByType = {
                building: "/building/dashboard",
                bridge: "/bridge/dashboard",
                tunnel: "/tunnel-segment/dashboard",
            };
            const typeDashboard = dashboardByType[new_project_type] ?? "/";

            // Always fetch fresh modules for the selected project type via the
            // permissions store (single source of truth).
            let modules = [];
            try {
                modules = await this.$store.dispatch(
                    "permissions/reload",
                    item.type,
                );
            } catch (error) {
                processErrors();
            }

            // Same project type → try to remain on the current page, but only
            // if the user still has permission for it under the new project.
            // Different project type → always navigate away.
            const isSuperAdmin =
                this.$store.getters["permissions/isSuperAdmin"];
            const allowedLinks =
                this.$store.getters["permissions/allowedLinks"];

            const canStayOnCurrentRoute =
                same_project_type &&
                current_route &&
                current_route.path &&
                current_route.path !== "/" &&
                !current_route.meta?.public &&
                (isSuperAdmin || isPathAllowed(current_route, allowedLinks));

            if (canStayOnCurrentRoute) {
                // Remount the current view so it refetches with the new project.
                this.refreshKey++;
            } else {
                const firstPath = getFirstAllowedPath(modules || []);
                const navigateTo =
                    firstPath !== "/" ? firstPath : typeDashboard;
                this.$router.push(navigateTo);
            }

            if (forceReload) this.getProjectShortcut();

            setTimeout(() => {
                this.screen_loading = false;
            }, 500);

            this.settingDialog = false;
        },
        getThisBrowser() {
            const userAgent = navigator.userAgent;

            //chrome, chromium, crios
            if (userAgent.match(/chrome|chromium|crios/i)) {
                return true;
            }

            //edge
            if (userAgent.match(/edg/i)) {
                return true;
            }

            //firefox, fxios
            if (userAgent.match(/firefox|fxios/i)) {
                return false;
            }

            //safari
            if (userAgent.match(/safari/i)) {
                return false;
            }

            //opera
            if (userAgent.match(/opr\//i)) {
                return false;
            }
            //internet explorer
            if (userAgent.match(/trident/i)) {
                return false;
            }

            return false;
        },
        handleDrawerMouseLeave() {
            this.isHoveringDrawer = false;
            this.isHoveringMenu = false;
        },
        handleMenuMouseLeave() {
            this.isHoveringMenu = false;
        },
        setProjectTitle() {
            const get_project = JSON.parse(localStorage.getItem("project"));
            if (!get_project) {
                this.project_selected = false;
                this.select_project_button_code = "Select Project";
                this.select_project_button_name = null;
                this.select_project_id = null;
            } else {
                this.select_project_button_code = get_project.project_code;
                this.select_project_button_name = get_project.project_name;
                this.project_selected = true;
                this.project_type = get_project.type;
                this.select_project_id = get_project.project_id;
            }
        },
        clearProjectShortcut() {
            localStorage.removeItem("project");
            // Drop project-scoped permissions when project is deselected.
            this.$store.dispatch("permissions/clear");
            this.select_project_button_code = "Select Project";
            this.select_project_button_name = null;
            this.select_project_id = null;
            this.project_type = null;
            this.project_selected = false;
            this.$router.push("/general-dashboard");
        },
        async requestSelectProject($event, auto = false) {
            if (auto) {
                this.projectShortcut($event);
                // this.getProjectShortcut();
                return;
            }
            this.settingDialog = true;
        },
        isModuleActive(module) {
            // Check if this module or any of its submodules is active
            if (module.submodule.length === 0) {
                return this.$route.path === module.link;
            } else {
                return module.submodule.some(
                    (sub) => this.$route.path === sub.link,
                );
            }
        },
        handleKeydown(event) {
            // Check for Ctrl + K (Windows/Linux) or Cmd + K (Mac)
            if ((event.ctrlKey || event.metaKey) && event.key === "k") {
                // Don't trigger if user is typing in an input field
                const activeElement = document.activeElement;
                const isInInput =
                    activeElement &&
                    (activeElement.tagName === "INPUT" ||
                        activeElement.tagName === "TEXTAREA" ||
                        activeElement.isContentEditable);

                if (!isInInput) {
                    event.preventDefault();
                    this.openSearchDialog();
                }
            }
        },
        openSearchDialog() {
            if (this.project_selected && this.project_type) {
                this.showSearchDialog = true;
            }
        },
        onModuleSelected(result) {
            // Navigate to the selected module/submodule
            this.$router.push(result.link);

            // Store module information in localStorage if needed
            if (result.type === "submodule") {
                localStorage.setItem("module_id", result.parentId);
                localStorage.setItem("sub_module_id", result.id);
            } else {
                localStorage.setItem("module_id", result.id);
                localStorage.removeItem("sub_module_id");
            }
        },
        getProjectTypeIcon() {
            const project_type = this.project_type?.toLowerCase();
            switch (project_type) {
                case "building":
                    return this.mdiOfficeBuildingOutline;
                case "tunnel":
                    return this.mdiTunnelOutline;
                case "bridge":
                    return this.mdiBridge;
                default:
                    return this.mdiOfficeBuildingOutline;
            }
        },
        getProjectIconColor() {
            const project_type = this.project_type?.toLowerCase();
            switch (project_type) {
                case "building":
                    return "project-badge-building-icon-color";
                case "tunnel":
                    return "project-badge-tunnel-icon-color";
                case "bridge":
                    return "project-badge-bridge-icon-color";
                default:
                    return "project-badge-building-icon-color";
            }
        },
        toggleTheme() {
            this.isDark = !this.isDark;
            const theme = this.isDark ? "dark" : "light";
            this.$vuetify.theme.global.name = theme;
            localStorage.setItem("color_theme", theme);
        },
    },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");

body {
    font-family: "Inter", sans-serif;
}

::-webkit-scrollbar {
    width: 8px;
    /* Width of the scrollbar */
    height: 8px;
}

::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-thumb);
    /* Color of the scrollbar thumb */
    border-radius: 6px;
    /* Rounded corners */
}

::-webkit-scrollbar-thumb:hover {
    background-color: var(--scrollbar-thumb-hover);
}

::-webkit-scrollbar-track {
    background-color: var(--card);
    /* Color of the scrollbar track */
}

* {
    scrollbar-color: var(--ring) var(--card);
}

body,
html {
    // background-color: #f9fafb;
    // background-color: #fafafa;
    // background-color: var(--bg-color);
    height: 100%;
    overflow: hidden !important;
}

#app {
    //   height: calc(100% - 92px);
    height: calc(100% - 56px);
}

.grey-card {
    background-color: rgba(0, 0, 0, 0.04);
}

.set-custom-height {
    height: 100vh;
    height: 100dvh;
    // background-color: var(--bg-color);
    background-color: var(--background);
}

#set_inner_container_height {
    // padding: 1.5rem;
    // padding-top: 56px;
    // min-height: calc(100vh - 56px);
    // background-color: var(--c-bg-2);
    padding: 0.25rem 1rem 1rem 1rem;
    // min-height: 100vh;
    height: 100vh;
    height: 100dvh;
    width: 100% !important;
    justify-content: center;
    display: flex;
    // overflow: hidden;

    &.has-top-nav-offset {
        margin-top: 56px;
        height: calc(100vh - 56px);
        height: calc(100dvh - 56px);
    }

    &.login-page {
        padding-top: 1rem;
    }

    #page_containter {
        /* shadcn "inset" layout: outer shell = --sidebar, content = --background.
           Light: #fafafa shell / white card. Dark: #171717 shell / #0a0a0a card,
           which keeps the sidebar visually separated from the content. */
        background-color: var(--secondary);
        border-radius: 1rem;
        // border: 1px solid var(--border);
        // box-shadow: 0 0 0 1px rgba(9, 9, 11, 0.05);
        // box-shadow: 0 0 0 1px rgb(59 130 246 / 0.5);
        // background-color: var(--inner-bg-color);
        width: 100%;
        // height: 100vh;
        // max-width: 1920px;

        // &.has-top-nav #page_content {
        //     max-height: calc(100vh - 78px);
        // }

        #page_content {
            // height: calc(100vh - 78px);
            height: 100%;
            overflow: auto;
            padding: 1rem;
            // scrollbar-width: none;

            // @media (max-width: 600px) {
            //     scrollbar-width: none;
            // }
        }

        @media only screen and (max-width: 767.5px) {
            border-radius: 0;
            height: 100%;
            min-height: 0;
            display: flex;
            flex-direction: column;

            #page_content {
                flex: 1;
                min-height: 0;
                height: auto;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
                padding-bottom: calc(
                    1rem + env(safe-area-inset-bottom, 0px)
                );
            }
        }
    }

    @media only screen and (max-width: 767.5px) {
        padding: 0;

        &.has-top-nav-offset {
            height: calc(100vh - 56px);
            height: calc(100dvh - 56px);
        }
    }
}

.v-breadcrumbs-item {
    padding: 0 !important;
}

.custom-table-block {
    padding: 1rem;
    border-radius: 0.375rem;
    background-color: white;
}

.text-type-main {
    font-size: 16px;
    font-weight: 500;
}

.text-type-sub {
    font-size: 14px;

    &-mini {
        font-size: 12px;
    }
}

.light-grey-border {
    border: 1px solid #e9ecef;
}

.bg-light-grey {
    background-color: #e9ecef;
}

.profile-avatar {
    height: 40px;
    width: 40px;
}

.swal2-html-container ul {
    list-style-type: none;
}

.dp__pointer.dp__input.dp__input_icon_pad.dp__input_reg {
    border: 1px solid #bdbdbd;
}

.dp__pointer.dp__input.dp__input_icon_pad.dp__input_reg:hover {
    border: 1px solid black;
}

.dp__disabled.dp__input_readonly.dp__input.dp__input_icon_pad.dp__input_reg:hover,
.dp__disabled.dp__input_readonly.dp__input.dp__input_icon_pad.dp__input_reg:disabled {
    border: 1px solid #e0e0e0;
    color: #bdbdbd;
    background-color: white;
}

.v-navigation-drawer--rail {
    .v-list-item {
        .v-list-item-title {
            opacity: 0;
            transition: opacity 0.1s ease-out;
        }
    }
}

.v-navigation-drawer--expand-on-hover:hover {
    .v-list-item {
        .v-list-item-title {
            opacity: 1;
            transition: opacity 0.2s ease-in;
        }
    }
}

.mobile-only {
    display: none;
}

.submodule-container {
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.2s ease-out;

    &.active {
        max-height: 1000px; // 设置一个足够大的值
        transition: max-height 0.4s ease-in;
    }

    .submodule-content {
        border-radius: var(--radius-md);
        background-color: var(--muted);
        padding: 0.5rem 0;
    }
}

.module-arrow {
    transition: transform 0.2s ease;
    transform: rotate(0deg);

    &.active {
        transform: rotate(90deg);
    }
}

.active-module,
.active-submodule {
    color: var(--primary);
    background-color: var(--blue-50);
}

.custom-selector-item-with-dropdown {
    height: 32px;
    min-width: 200px;
    width: 200px;
    background-color: white;
    border-radius: 6px;
    //   border-radius: 6px;
    border: 1px solid var(--border-color);
    //   --my-shadow: 0px 0px 0px 1px rgba(9, 9, 11, 0.07),
    //     0px 2px 2px 0px rgba(9, 9, 11, 0.05);
    //   --my-shadow-colored: 0px 0px 0px 1px var(--my-shadow-color),
    //     0px 2px 2px 0px var(--my-shadow-color);
    //   box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
    //     var(--tw-ring-shadow, 0 0 #0000), var(--my-shadow);

    .dropdown-icon {
        margin-left: auto;
    }
}

.custom-input-wrapper,
.custom-search-bar {
    width: 200px;

    &.long-type {
        width: 350px;

        .v-field__append-inner {
            padding-top: 0;
            align-items: center;
        }
    }
}

.mobile-material-btn {
    position: fixed;
    bottom: calc(16px + env(safe-area-inset-bottom, 0px));
    right: 16px;
    z-index: 1;
}

/* ── Nav project chip ─────────────────────────────────── */
.nav-project-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.125rem;
    padding: 0.25rem 0.5rem;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    background-color: var(--foreground);
    // color: var(--background);
    color: var(--background) !important;
    font-size: 0.75rem;
    line-height: 1;
    font-weight: 500;
    height: 34px;
    // transition: filter 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;

    &:hover {
        filter: brightness(1.06);
    }

    .nav-project-code {
        font-weight: 700;
        font-size: 11px;
        letter-spacing: 0.6px;
        text-transform: uppercase;
    }

    .nav-chip-sep {
        opacity: 0.5;
        font-size: 14px;
        line-height: 1;
    }

    .nav-project-name {
        font-size: 12px;
        max-width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

/* ── Nav vertical divider ────────────────────────────── */
.nav-vdivider {
    width: 1px;
    height: 22px;
    background: #e5e7eb;
}

/* ── Nav avatar trigger ──────────────────────────────── */
.nav-avatar-trigger {
    display: flex;
    gap: 0.5rem;
    cursor: pointer;
    align-items: center;
    width: 100%;
    padding: 0.5rem;
    transition: border-color 0.15s, box-shadow 0.15s;

    &:hover {
        background-color: var(--surface-color);
    }

    img {
        border-radius: 20%;
        width: 40px;
        height: 40px;
        object-fit: cover;
        display: block;
    }
}

.nav-menu-btn {
    color: #6b7280;
    flex-shrink: 0;
}

.sw-custom-border {
    height: 100%;
    --my-shadow: 0px 0px 0px 1px rgba(9, 9, 11, 0.07),
        0px 2px 2px 0px rgba(9, 9, 11, 0.05);
    --my-shadow-colored: 0px 0px 0px 1px var(--my-shadow-color),
        0px 2px 2px 0px var(--my-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
        var(--tw-ring-shadow, 0 0 #0000), var(--my-shadow);
}

.card-title-custom {
    display: flex;
    padding-top: 1rem;
    gap: 0.5rem;
    align-items: center;
    padding-left: 1.5rem;
}

@media only screen and (max-width: 767.5px) {
    .custom-input-wrapper,
    .custom-search-bar {
        width: 100%;

        &.long-type {
            width: 100%;
        }
    }

    .custom-selector-item-with-dropdown {
        min-width: 100%;
        width: 100%;
    }

    .mobile-only {
        display: flex;
    }

    .desktop-only {
        display: none;
    }
}

.v-toolbar__content {
    height: 56px !important;
    padding: 0 1rem;
}

.title-control {
    display: none !important;
}

.sidebar-company-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.375rem 0.5rem;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.15s;
    min-height: 36px;

    &:hover {
        background-color: var(--sidebar-item-hover);
    }
}

.sidebar-company-logo {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}

.v-navigation-drawer__content {
    scrollbar-width: none !important;
}

/* ── Sidebar (Linear/Tailwind style) ───────────────────── */
.tailwind-sidebar {
    width: 256px !important;
    background-color: var(--background);
    // border-right: 1px solid var(--sidebar-border) !important;
    border: none;
    // height: calc(100vh - 1px) !important;

    &.has-top-nav {
        top: 56px !important;
        height: calc(100% - 56px) !important;
    }

    /* Make the vuetify drawer inner scroller a flex column */
    :deep(.v-navigation-drawer__content) {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: hidden;
    }

    /* ── Company header ── */
    .sidebar-company-header {
        padding: 0.5rem 0.5rem 0.25rem;
        flex-shrink: 0;
    }

    .sidebar-company-name {
        font-size: 13.5px;
        font-weight: 600;
        color: var(--sidebar-text-primary);
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .sidebar-company-chevron {
        color: var(--sidebar-text-muted) !important;
        flex-shrink: 0;
    }

    /* ── Utility nav (Search, Project) ── */
    .sidebar-utility-nav {
        padding: 0.375rem;
        display: flex;
        flex-direction: column;
        gap: 1px;
        flex-shrink: 0;

        .project-icon-frame {
            background-color: var(--card-foreground);
            color: var(--background);
            border-radius: var(--radius);
            padding: 0.25rem;
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .sidebar-util-item {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.3125rem 0.5rem;
        border-radius: 6px;
        min-height: 30px;
        transition: background 0.15s;

        &:hover {
            background-color: var(--accent);
        }
    }

    .sidebar-util-icon {
        color: var(--sidebar-text-muted) !important;
        flex-shrink: 0;
    }

    .sidebar-util-label {
        font-size: 13px;
        color: var(--sidebar-text-secondary);
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-transform: capitalize;
        width: 100%;
        max-width: 160px;
    }

    .sidebar-kbd {
        display: inline-flex;
        align-items: center;
        padding: 0 5px;
        height: 18px;
        border: 1px solid var(--sidebar-border);
        border-radius: 4px;
        font-size: 10.5px;
        font-family: inherit;
        color: var(--sidebar-text-muted);
        background: transparent;
        white-space: nowrap;
        flex-shrink: 0;
    }

    /* ── Scrollable content ── */
    .sidebar-content {
        flex: 1;
        overflow-y: auto;
        padding: 0.375rem 0.5rem;
        scrollbar-width: none;
        height: calc(100vh - 167px);

        &::-webkit-scrollbar {
            display: none;
            width: 0;
            height: 0;
        }
    }

    /* ── nav links inside sidebar-content (from sidebar-content.vue) ── */
    .sub-nav-link-wrapper {
        border-left: 2px solid var(--sidebar-border);
        transition: border-color 0.15s;

        &.active-sub-nav-link-wrapper {
            border-left-color: var(--sidebar-primary);
        }
        &:hover {
            border-left-color: var(--sidebar-primary);
        }
    }

    .nav-link,
    .sub-nav-link {
        display: block;
        margin-left: 0.25rem;
        padding: 0.3125rem 0.625rem;
        border-radius: 5px;
        font-size: 13px;
        text-decoration: none;
        color: var(--sidebar-text-secondary);
        transition: background 0.12s, color 0.12s;

        &:hover {
            background-color: var(--sidebar-item-hover);
            color: var(--sidebar-text-primary);
            text-decoration: none;
        }

        &.router-link-active {
            background-color: var(--sidebar-accent);
            color: var(--sidebar-accent-foreground);
            font-weight: 500;
        }
    }

    /* ── Loading skeleton ── */
    .sidebar-loading-skeleton {
        padding: 0.5rem 0;
    }

    .skel-label {
        height: 10px;
        width: 40%;
        background: var(--sidebar-item-hover);
        border-radius: 4px;
        margin-bottom: 8px;
        animation: skel-pulse 1.5s ease-in-out infinite;
    }

    .skel-item {
        height: 28px;
        background: var(--sidebar-item-hover);
        border-radius: 5px;
        margin-bottom: 4px;
        animation: skel-pulse 1.5s ease-in-out infinite;

        &--short {
            width: 70%;
        }
    }

    /* ── Bottom area ── */
    .sidebar-bottom {
        flex-shrink: 0;
        padding-bottom: 0.25rem;
    }

    .sidebar-bottom-nav {
        padding: 0.25rem 0.5rem;
        display: flex;
        flex-direction: column;
        gap: 1px;
    }

    .sidebar-bottom-divider {
        margin: 0.25rem 0.75rem;
        border-top: 1px solid var(--sidebar-border);
    }

    .sidebar-user-row {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.375rem 0.75rem 0.5rem;
        border-radius: 6px;
        margin: 0 0.25rem;
        transition: background 0.15s;
        height: 46px;

        &:hover {
            background-color: var(--sidebar-item-hover);
        }
    }

    .sidebar-user-avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        object-fit: cover;
        flex-shrink: 0;
    }

    .sidebar-user-info {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
    }

    .sidebar-user-name {
        font-size: 12.5px;
        font-weight: 500;
        color: var(--sidebar-text-primary);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 1.3;
    }

    .sidebar-user-email {
        font-size: 11px;
        color: var(--sidebar-text-muted);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 1.3;
    }

    .sidebar-user-chevron {
        color: var(--sidebar-text-muted) !important;
        flex-shrink: 0;
    }
}

@keyframes skel-pulse {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.45;
    }
}

.hover\:text-card-foreground:hover {
    color: var(--neutral-900);
}

.hover\:text-red-500:hover {
    color: #ef4444;
}

@keyframes pulse {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.logo-container {
    position: relative;
    height: 100px;
    width: 100px;
    display: flex;
    padding: 0.5rem;
    margin: 0 auto;
    //   background: #1c1f2b;
    background: var(--card);
    text-align: center;
    border-radius: 10px;
    z-index: 1;

    .loading-logo {
        object-fit: contain;
        height: 100%;
        width: 100%;
    }
}

@property --angle {
    syntax: "<angle>";
    initial-value: 0deg;
    inherits: false;
}

/* 旋转边框卡片动画效果 */
.animated-border-card {
    position: relative;
    border-radius: 14px;
    padding: 1rem;
    text-align: center;
    overflow: hidden;
    margin: 0 auto;
    // box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.animated-border-card::before {
    --angle: 0deg;
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    inset: -4px;
    border-radius: 10px;
    background: conic-gradient(
        from var(--angle),
        #006aff,
        #0000ff,
        #00d4ff,
        #00ffb2,
        #00ff7f
    );
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    padding: 3px;
    // z-index: -1;
    animation: spin 3s linear infinite;
}

.animated-border-card::after {
    content: "";
    position: absolute;
    inset: 4px;
    border-radius: 10px;
    // background: #23243a;
    background: var(--background);
    // z-index: -1;
}

.animated-border-card::before {
    filter: blur(1rem);
    // opacity: 0.5;
}

@keyframes spin {
    from {
        --angle: 0deg;
    }
    to {
        --angle: 360deg;
    }
}

// @keyframes rotateBorder {
//   0% {
//     transform: rotate(0deg);
//   }
//   100% {
//     transform: rotate(360deg);
//   }
// }

.animated-border-card .logo-container {
    background: transparent;
    box-shadow: none;
    position: relative;
    z-index: 1;
}

.animated-border-card .logo-container-wrapper {
    position: relative;
    z-index: 1;
}

.animated-border-card span {
    position: relative;
    z-index: 1;
    color: var(--foreground);
}

.mini-badge {
    font-size: 11px;
    background-color: var(--secondary);
    color: var(--muted-foreground);
    padding: 2px 6px;
    border-radius: 4px;
    text-transform: uppercase;
}
</style>
